import React, { useEffect, useMemo, useState } from "react"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file
import { calculateTotal } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import { apiRoute } from "../../constants/enum.js"
import { useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
} from "../../components/NextUITable.jsx"
import { faFilter, faMagnifyingGlass, } from "@fortawesome/free-solid-svg-icons"
import { Button, Autocomplete, AutocompleteItem } from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"

const FinishStock = () => {
  const { compCode, } = useSelector((state) => state.company)
  const [selectedItem, setSelectedItem] = useState("")
   const [selectedCategory, setSelectedCategory] = useState("")
  //{ key: "", value: "" })
  const [data, setData] = useState([])
  const [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  })

  const { data: itemMasterData = [] } = useFetchWithBody({
    url: apiRoute.stock.fetchItemMaster,
    queryKey: "StockItemMaster",
  })

   const { data: masterData = [] } = useFetchWithBody({
      url: apiRoute.item.masterData,
      queryKey: "fetchMasterData"
    })

  const handleResetFilter = () => {
    setSelectedItem("")
    setFilterDate({ start: null, end: null })
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: null,
        item_cat:null,
        from_date: null,
        to_date: null
      }
    })
  }


  const {
    data: stockData = [],
    isError,
    isPending,
    mutate: filterStock,
  } = usePost({
    url: apiRoute.stock.fetchFinishStock,
    queryKey: "GetFinishStock",

  })
  useEffect(() => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: null,
        item_cat:null,
        from_date: null,
        to_date: null,
      }
    })

  }, [])

  useEffect(() => {
    setData(stockData)
  }, [stockData])

  const handleDataChange = ({ data, isFilter }) => {
    if (isFilter)
      setData(data)
    else
      setData(stockData)
  }
  let totalPWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "PWeight",
      }),
    [data]
  )
  let totalCarton = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "PCartoon",
      }),
    [data]
  )
  let totalPTPcs = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "PTPcs",
      }),
    [data]
  )
  let totalRolls = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Rolls",
      }),
    [data]
  )
  let totalRWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "RWeight",
      }),
    [data]
  )
  let totalTRolls = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TRolls",
      }),
    [data]
  )
  let totalTWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TWeight",
      }),
    [data]
  )

  const handleFilter = () => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        item_code: selectedItem, //.key
        item_cat:selectedCategory,
        from_date: filterDate.start ? new Date(filterDate.start).toISOString().split("T")[0] : null,
        to_date: filterDate.end ? new Date(filterDate.end).toISOString().split("T")[0] : null,
      }
    })
  }

  let downloadDataFooter = {
    Item_Code: "",
    Item_Name: "",
    L_Code: "",
    PCartoon: "Total: " + totalCarton,
    PTPcs: "Total: " + totalPTPcs,
    PWeight: "Total: " + totalPWeight,
    Rolls: "Total: " + totalRolls,
    RWeight: "Total: " + totalRWeight,
    TRolls: "Total: " + totalTRolls,
    TWeight: "Total: " + totalRWeight
  }

  const exportColumns = [
    {
      uid: "Item_Code",
      name: "Item Code",
    },
    {
      uid: "Item_Name",
      name: "Item Name",
    },
    {
      uid: "L_Code",
      name: "Lot No",
    },
    {
      uid: "PCartoon",
      name: "Carton",
    },
    {
      uid: "PTPcs",
      name: "Rolls",
    },
    {
      uid: "PWeight",
      name: "Weight",
    },
    {
      uid: "Rolls",
      name: "Rolls Stock",

    },
    {
      uid: "RWeight",
      name: "Rolls Weight",
    },
    {
      uid: "TRolls",
      name: "Total Rolls",
    },
    {
      uid: "TWeight",
      name: "Total Weight",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "Item_Code",
    "Item_Name",
    "L_Code",
    "PCartoon",
    "PTPcs",
    "PWeight",
    "Rolls",
    "RWeight",
    "TRolls",
    "TWeight"
  ]

  const columns = [
    {
      uid: "Item_Code",
      name: "Item Code",
      sortable: true,
    },
    {
      uid: "Item_Name",
      name: "Item Name",
      sortable: true,
    },
    {
      uid: "L_Code",
      name: "Lot No",
      sortable: true,
    },
    {
      uid: "PCartoon",
      name: "Carton",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalCarton,
      },
    },
    {
      uid: "PTPcs",
      name: "Rolls",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalPTPcs,
      },
    },
    {
      uid: "PWeight",
      name: "Weight",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalPWeight,
      },
    },
    {
      uid: "Rolls",
      name: "Rolls Stock",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalRolls,
      },
    },
    {
      uid: "RWeight",
      name: "Rolls Weight",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalRWeight,
      },
    },
    {
      uid: "TRolls",
      name: "Total Rolls",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalTRolls,
      },
    },
    {
      uid: "TWeight",
      name: "Total Weight",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total",
        value: totalTWeight,
      },
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Finish Product Stock" info={[]} breadcrumbs={[ "Finish Product Stock"]}>
        <div className="flex w-full flex-col">

          <div className="flex  flex-wrap items-center gap-2  mb-2">
            <div className={`${isMobile?"flex-wrap":""} flex items-center gap-2 `}>
              <Autocomplete
                size="sm"
                label="Category"
                c className={`${isMobile ? "w-full" : "max-w-36"} `}
                defaultItems={masterData && masterData.itemCategory
                  ? masterData.itemCategory
                  : []}
                isVirtualized
                variant="bordered"
                placeholder={"--Select--"}
                selectedKey={selectedCategory}
                onSelectionChange={setSelectedCategory}
              >
                {(item) => (
                  <AutocompleteItem key={item.CAT}>
                    {item.CAT}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              <Autocomplete
                size="sm"
                name={"item"}
                label={"Product Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className={`${isMobile ? "w-full" : "max-w-60"} `}
                classNames={{
                  label: "text-xs text-black font-bold",
                }}
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData
                    ? itemMasterData : []
                }
                onSelectionChange={setSelectedItem}
                selectedKey={selectedItem}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Item_Code}
                  >
                    {list.Item_Desc}
                  </AutocompleteItem>
                )}
              </Autocomplete>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Start Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={
                    filterDate.start
                      ? dayjs(filterDate.start)
                      : filterDate.start
                  }
                  onChange={(newValue) => {
                    setFilterDate((prev) => {
                      return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  sx={{ width: "150px" }}
                  slotProps={{ textField: { size: "small" } }}
                />
                <DatePicker
                  label={"End Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={
                    filterDate.end ? dayjs(filterDate.end) : filterDate.end
                  }
                  onChange={(newValue) => {
                    setFilterDate((prev) => {
                      return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  sx={{ width: "150px" }}
                />
              </LocalizationProvider>


            </div>
            <div className={`${isMobile?"justify-center mb-5 w-full":""}  flex   items-center gap-2 `}>
              <Button
               size="sm"
                color="primary"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
                //className={`${isMobile?"w-1/2":""}`}
              // isLoading={isPending}
              >
                Search
              </Button>
              <Button
              size="sm"
                style={{ marginLeft: "5px" }}
                color="warning"
                startContent={<FontAwesomeIcon icon={faFilter} />}
                onPress={handleResetFilter}
              >
                Reset
              </Button>
            </div>
          </div>

        </div>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          handleDataChange={handleDataChange}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="Finish_Product_Stock_Summary"
          id="Item_Code"
        />
      </MainContainer>
    </div>
  )
}

export default FinishStock
